module.exports = __webpack_public_path__ + "img/IClaim.dfb12e92.svg";